<template>
  <v-card class="redeem-coupon">
    <v-card-title>{{ $t('coupon.redeem_title') }}</v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-form ref="form">
          <v-text-field outlined
                        :label="$t('coupon.redeem_code')"
                        hide-details="auto"
                        v-model="redeemCode"
                        :rules="requiredRules"></v-text-field>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit')">
        {{ $t('close') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && submit()">
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {computed, onMounted, ref} from "@vue/composition-api";

export default {
  name: 'RedeemCouponModal',
  props: {
    couponGroupId: String,
  },
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const redeemCode = ref(null);
    const submit = function () {
      root.$callAPI('aafb/coupon/redeem/', {
        redeem_code: redeemCode.value,
      }, function (response) {
        emit('submit', response.body.coupon);
        root.$showAlertMessage(root.$t('coupon.redeem_success_msg'));
      })
    }

    return {
      requiredRules,
      redeemCode,

      submit
    }
  }
}
</script>

<style lang="less">
.redeem-coupon {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .v-card__title, .v-card__text, .v-card__actions {
    width: 100%;
  }

  .v-card__title, .v-card__actions {
    flex: 0 0 auto;
  }

  .v-card__text {
    flex: 1 1 auto;
    overflow: auto;
  }
}


</style>
